import React from 'react'

const configData = window.CS_CONFIG

const EnvironmentName: React.FC = () => configData.Env.toLowerCase() === 'production'
    ? null
    : <div id="env-indicator">{configData.Env}</div>

export default EnvironmentName
